import { createAction, props } from '@ngrx/store';

import { KycIdentification } from '@models/kyc-identification.model';

export const SELECT = '[KycIdentification] Select';
export const UPDATE = '[KycIdentification] Update';
export const LOAD = '[KycIdentification] Load';
export const LOAD_SUCCESS = '[KycIdentification] Load Success';
export const REMOVE = '[KycIdentification] Remove';

export const select = createAction(SELECT, props<{ kycIdentification: KycIdentification }>());
export const update = createAction(UPDATE, props<{ kycIdentification: KycIdentification }>());
export const load = createAction(LOAD);
export const loadSuccess = createAction(LOAD_SUCCESS, props<{ kycIdentification: KycIdentification }>());
export const remove = createAction(REMOVE);
